import { forwardRef } from 'react'
import { Sheet } from 'react-modal-sheet'
import { cn } from '~utils/cn'
import { BOTTOM_SHEET_HEADER_LONG_HANDLER_STYLE } from './constants'

interface BottomSheetProps {
  isOpen: boolean
  onCloseRequest: () => void
  tapBackdropToClose?: boolean
  children: React.ReactNode
  detent?: 'content-height' | 'full-height'
}
const BottomSheet = forwardRef<typeof Sheet, BottomSheetProps>(
  (
    {
      isOpen,
      onCloseRequest,
      children,
      tapBackdropToClose: tapBackdropToClose = true,
      detent = 'content-height',
    },
    ref
  ) => {
    return (
      <Sheet ref={ref} isOpen={isOpen} onClose={onCloseRequest} detent={detent}>
        <Sheet.Backdrop onTap={tapBackdropToClose ? onCloseRequest : undefined} />
        <Sheet.Container
          className="[&_div]:no-scrollbar"
          style={{
            borderTopLeftRadius: 24,
            borderTopRightRadius: 24,
            overflow: 'hidden',
          }}
        >
          <Sheet.Header
            className={cn(
              BOTTOM_SHEET_HEADER_LONG_HANDLER_STYLE,
              'bg-background dark:bg-gray-800 h-8'
            )}
          />
          <Sheet.Content className="bg-background dark:bg-gray-800">{children}</Sheet.Content>
        </Sheet.Container>
      </Sheet>
    )
  }
)

BottomSheet.displayName = 'BottomSheet'

export default BottomSheet
